export const translations = {
  ro: {
    nav: {
      home: "Acasă",
      services: "Servicii",
      about: "Despre noi",
      clients: "Clienți",
      contact: "Contact",
      quote: "Cere ofertă",
    },
    common: {
      tagline: "Reparații industriale benzi transportoare",
      callUs: "Sună acum",
      writeUs: "Scrie-ne",
      since: "Din 2008",
      yearsExperience: "ani de experiență",
      projectsDone: "intervenții realizate",
      industries: "industrii deservite",
      coverage: "acoperire națională",
    },
    home: {
      eyebrow: "Conveyor Belts S.R.L. // Făurei, Brăila",
      heroTitle: "Repunem în mișcare\nbenzile care\nopresc producția.",
      heroSub:
        "Vulcanizare la cald, joncțiuni la rece, reparații de urgență și mentenanță programată pentru benzi transportoare de cauciuc — direct la fața locului, 24/7.",
      ctaPrimary: "Solicită intervenție",
      ctaSecondary: "Vezi serviciile",
      whatWeDo: "Ce facem",
      whatWeDoTitle: "Servicii complete pentru benzi de cauciuc",
      whatWeDoSub:
        "Echipe mobile, echipamente proprii și piese de schimb pregătite pentru orice tip de bandă, indiferent de lățime sau industrie.",
      whyUs: "De ce noi",
      whyUsTitle: "Reducem timpul de oprire la minimum.",
      reasons: [
        {
          k: "01",
          t: "Răspuns rapid",
          d: "Echipele noastre se mobilizează în maxim 24h în toată țara, cu unități mobile de vulcanizare.",
        },
        {
          k: "02",
          t: "Tehnologie certificată",
          d: "Vulcanizare la cald cu prese profesionale și materiale conform standardelor DIN/ISO.",
        },
        {
          k: "03",
          t: "Garanție pe lucrare",
          d: "Toate joncțiunile și reparațiile vin cu garanție și raport tehnic detaliat.",
        },
        {
          k: "04",
          t: "Mentenanță preventivă",
          d: "Programe periodice de inspecție care previn ruperea benzii și opririle neplanificate.",
        },
      ],
      ctaBannerTitle: "Banda s-a rupt? Te sunăm înapoi în 15 minute.",
      ctaBannerSub:
        "Lasă-ne numărul tău și un specialist te contactează cu o estimare preliminară.",
    },
    services: {
      eyebrow: "Servicii // 05 specializări",
      title: "Tot ce ține o bandă\nîn mișcare.",
      sub:
        "De la joncțiuni de urgență pe câmp până la programe complete de mentenanță în carieră — acoperim întreg ciclul de viață al unei benzi transportoare de cauciuc.",
      list: [
        {
          id: "hot",
          n: "01",
          t: "Vulcanizare la cald",
          d: "Joncțiuni permanente realizate cu prese de vulcanizare, materiale originale și control de temperatură. Rezistență maximă, durabilitate pe termen lung.",
          bullets: [
            "Benzi EP, NN, ST",
            "Lățimi 400–2200 mm",
            "Prese mobile la fața locului",
          ],
        },
        {
          id: "cold",
          n: "02",
          t: "Reparații la rece",
          d: "Soluție rapidă pentru opriri neașteptate. Adezivi industriali și petice cauciucate aplicate fără echipament greu — banda repornește în câteva ore.",
          bullets: [
            "Intervenții de urgență 24/7",
            "Adezivi cu performanță ridicată",
            "Soluție temporară sau definitivă",
          ],
        },
        {
          id: "splice",
          n: "03",
          t: "Joncțiuni benzi transportoare",
          d: "Joncțiuni mecanice și chimice, executate la unghi corect, cu echipamente de aliniere — pentru transferuri silențioase și fără vibrații.",
          bullets: [
            "Joncțiuni mecanice cu cleme",
            "Joncțiuni vulcanizate",
            "Aliniere și calibrare",
          ],
        },
        {
          id: "replace",
          n: "04",
          t: "Înlocuiri benzi",
          d: "Demontăm vechea bandă, livrăm și instalăm banda nouă cu echipele noastre. Furnizăm benzi noi din stoc partener sau la comandă.",
          bullets: [
            "Demontare și reciclare",
            "Bandă nouă livrată",
            "Instalare și tensionare",
          ],
        },
        {
          id: "maintenance",
          n: "05",
          t: "Mentenanță și inspecții",
          d: "Contracte de mentenanță cu inspecții periodice, măsurători de uzură și raportare tehnică. Previi avariile și prelungești viața benzii.",
          bullets: [
            "Audit tehnic complet",
            "Plan de mentenanță anual",
            "Raportare digitală",
          ],
        },
      ],
      extra: {
        t: "Și mai mult",
        d: "Reparații role, curățitoare de bandă, role de impact, alinieri și consultanță pentru proiectarea sistemelor de transport.",
      },
    },
    about: {
      eyebrow: "Despre // Conveyor Belts S.R.L.",
      title: "Cauciuc, oțel și\noameni care nu se opresc.",
      lead:
        "Suntem o echipă cu rădăcini în industria grea din sud-estul României. Din Făurei, județul Brăila, ne deplasăm în carierele, fabricile de ciment, porturile, terminalele agricole și fabricile din toată țara pentru a menține benzile transportoare în mișcare.",
      sections: [
        {
          t: "Misiunea noastră",
          d: "Reducem la zero timpul mort cauzat de defecțiunile benzilor de cauciuc. Lucrăm rapid, curat și transparent — exact așa cum am vrea să se lucreze la noi.",
        },
        {
          t: "Cum lucrăm",
          d: "Echipele noastre vin cu propriile echipamente — prese de vulcanizare, generatoare, scule de aliniere, dispozitive de tensionare. Tu nu pregătești nimic: descrii defectul, noi venim cu soluția.",
        },
        {
          t: "Standarde",
          d: "Lucrăm cu materiale conform standardelor DIN 22102, EN ISO 14890 și ISO 583. Fiecare intervenție vine cu raport tehnic și garanție explicită.",
        },
      ],
      stats: [
        { v: "16+", l: "ani de experiență" },
        { v: "800+", l: "intervenții realizate" },
        { v: "12", l: "industrii deservite" },
        { v: "24/7", l: "disponibilitate" },
      ],
    },
    clients: {
      eyebrow: "Clienți // industrii",
      title: "Oamenii care\nne dau alarma\nla 3 dimineața.",
      lead:
        "Lucrăm cu operatori industriali din toată țara — companii pentru care fiecare minut de oprire a benzii înseamnă pierderi reale.",
      industries: [
        {
          t: "Cariere & Mining",
          d: "Benzi de mare lățime pentru exploatări de agregate, pietriș, cărbune și minereuri.",
        },
        {
          t: "Fabrici de ciment",
          d: "Sisteme de transport pentru calcar, clincher și ciment, în medii cu temperatură și praf ridicate.",
        },
        {
          t: "Agricultură & Cereale",
          d: "Terminale portuare și silozuri — transport cereale, semințe și produse vrac.",
        },
        {
          t: "Construcții",
          d: "Stații de betoane, sortare agregate și fabrici de prefabricate.",
        },
        {
          t: "Industria lemnului",
          d: "Transport rumeguș, așchii și buștean pentru fabrici de cherestea și mobilă.",
        },
        {
          t: "Reciclare",
          d: "Linii de sortare deșeuri solide, plastice și metale.",
        },
        {
          t: "Energie",
          d: "Centrale termice și termocentrale pe biomasă.",
        },
        {
          t: "Porturi & Terminale",
          d: "Manipulare vrac portuar — minereuri, cereale, îngrășăminte.",
        },
      ],
      testimonialTitle: "Ce spun beneficiarii",
      logosTitle: "Companii cu care lucrăm",
      logosNote: "Selecție reprezentativă a industriilor și partenerilor deserviți.",
      logos: [
        "HOLCIM",
        "HEIDELBERG MATERIALS",
        "LAFARGE",
        "CARMEUSE",
        "PORTUL CONSTANȚA",
        "SOCEP",
        "TRANSPORT TRADE",
        "CEMACON",
        "AGRIROM",
        "MACON",
        "SOMACO",
        "ELPRECO",
      ],
      testimonials: [
        {
          q: "Au venit noaptea, au lucrat 6 ore și dimineața banda mergea. Profesionalism real.",
          a: "Director operațiuni, carieră agregate, Buzău",
        },
        {
          q: "Lucrăm cu ei de 4 ani pentru mentenanța preventivă. Avem zero opriri neplanificate.",
          a: "Inginer mecanic, fabrică ciment, Dobrogea",
        },
        {
          q: "Rapizi, corecți la preț și cu raport tehnic care chiar înseamnă ceva.",
          a: "Manager terminal portuar, Constanța",
        },
      ],
    },
    contact: {
      eyebrow: "Contact // 24/7",
      title: "Spune-ne ce s-a\nîntâmplat cu banda.",
      lead:
        "Trimite-ne câteva detalii și un specialist te contactează cu o estimare preliminară și un timp de intervenție.",
      form: {
        name: "Nume complet",
        namePh: "Ion Popescu",
        email: "Email",
        emailPh: "nume@companie.ro",
        phone: "Telefon",
        phonePh: "07XX XXX XXX",
        company: "Companie",
        companyPh: "Numele companiei",
        subject: "Subiect",
        subjectPh: "Reparație urgentă bandă...",
        message: "Mesaj",
        messagePh: "Descrie tipul benzii, lățimea, locația și natura problemei.",
        submit: "Trimite mesajul",
        sending: "Se trimite...",
        success: "Mesaj trimis! Te contactăm în cel mai scurt timp.",
        error: "Nu am putut trimite mesajul. Încearcă din nou sau sună-ne.",
      },
      info: {
        phoneL: "Telefon",
        emailL: "Email",
        addressL: "Sediu",
        address: "Oraș Făurei, str. Gării nr. 53, jud. Brăila",
        hoursL: "Program",
        hours: "Intervenții 24/7 · Birou L–V 08:00–17:00",
      },
    },
    footer: {
      rights: "Toate drepturile rezervate.",
      cui: "Conveyor Belts S.R.L. · Făurei, Brăila",
      nav: "Navigare",
      contact: "Contact",
      services: "Servicii",
    },
    seo: {
      home: {
        title: "Conveyor Belts S.R.L. | Reparații benzi transportoare de cauciuc — România & Europa",
        description: "Reparații benzi transportoare de cauciuc în România și Europa. Vulcanizare la cald, lipire bandă transportoare, joncțiuni și mentenanță 24/7. Alternativă românească la Artego și Ikosar. Făurei, jud. Brăila.",
        keywords: "reparații benzi transportoare Romania, lipire banda transportoare de cauciuc, vulcanizare bandă transportoare, joncțiuni benzi transportoare, rubber conveyor belts repair Europe, artego, ikosar, Conveyor Belts SRL Făurei Brăila",
      },
      services: {
        title: "Servicii — Vulcanizare, lipire și joncțiuni benzi transportoare | Conveyor Belts",
        description: "Servicii complete pentru benzi transportoare de cauciuc: vulcanizare la cald, lipire la rece, joncțiuni mecanice și chimice, înlocuiri benzi și mentenanță preventivă în toată România.",
        keywords: "vulcanizare bandă transportoare, lipire banda transportoare de cauciuc la rece, joncțiuni benzi transportoare, înlocuire bandă transportoare, mentenanță benzi transportoare, hot vulcanizing Romania",
      },
      about: {
        title: "Despre noi — Reparații benzi transportoare din 2008 | Conveyor Belts S.R.L.",
        description: "16+ ani de experiență în reparații benzi transportoare de cauciuc pentru industria grea din România. Echipe mobile, echipamente proprii, lucrări conforme DIN 22102 și EN ISO 14890.",
        keywords: "companie reparații benzi transportoare Romania, Conveyor Belts SRL, Făurei Brăila, DIN 22102, EN ISO 14890, alternativă artego ikosar",
      },
      clients: {
        title: "Clienți & Industrii deservite — Cariere, fabrici de ciment, porturi | Conveyor Belts",
        description: "Lucrăm cu operatori industriali din cariere, fabrici de ciment, porturi, agricultură, reciclare, energie și construcții. Referințe reale, timp de răspuns garantat.",
        keywords: "reparații benzi transportoare cariere, benzi transportoare fabrici de ciment, benzi transportoare port Constanța, benzi transportoare agricultură, clienți Conveyor Belts",
      },
      contact: {
        title: "Contact — Solicită intervenție 24/7 | Conveyor Belts S.R.L. Făurei, Brăila",
        description: "Sună 0737.906.906 sau completează formularul. Reparații benzi transportoare oriunde în România și Europa. Sediu: Str. Gării nr. 53, Făurei, jud. Brăila.",
        keywords: "contact reparații benzi transportoare, telefon Conveyor Belts, Făurei Brăila, intervenție urgentă bandă transportoare",
      },
    },
  },
  en: {
    nav: {
      home: "Home",
      services: "Services",
      about: "About",
      clients: "Clients",
      contact: "Contact",
      quote: "Get a quote",
    },
    common: {
      tagline: "Industrial conveyor belt repair",
      callUs: "Call now",
      writeUs: "Write us",
      since: "Since 2008",
      yearsExperience: "years of experience",
      projectsDone: "interventions completed",
      industries: "industries served",
      coverage: "national coverage",
    },
    home: {
      eyebrow: "Conveyor Belts S.R.L. // Făurei, Brăila",
      heroTitle: "We get the belts\nback in motion —\nbefore production stops.",
      heroSub:
        "Hot vulcanizing, cold splicing, emergency repairs and scheduled maintenance for rubber conveyor belts — on-site, 24/7.",
      ctaPrimary: "Request intervention",
      ctaSecondary: "See services",
      whatWeDo: "What we do",
      whatWeDoTitle: "Full-service solutions for rubber belts",
      whatWeDoSub:
        "Mobile crews, our own equipment and spare parts ready for any belt type — regardless of width or industry.",
      whyUs: "Why us",
      whyUsTitle: "We cut your downtime to the minimum.",
      reasons: [
        {
          k: "01",
          t: "Fast response",
          d: "Our crews mobilize within 24h across the country, with mobile vulcanizing units.",
        },
        {
          k: "02",
          t: "Certified technology",
          d: "Hot vulcanizing with professional presses and materials compliant with DIN/ISO.",
        },
        {
          k: "03",
          t: "Workmanship warranty",
          d: "All splices and repairs come with explicit warranty and a detailed technical report.",
        },
        {
          k: "04",
          t: "Preventive maintenance",
          d: "Periodic inspection programs that prevent belt failures and unplanned stops.",
        },
      ],
      ctaBannerTitle: "Belt down? We call you back within 15 minutes.",
      ctaBannerSub:
        "Leave us your number and one of our specialists will reach out with a preliminary estimate.",
    },
    services: {
      eyebrow: "Services // 05 specialties",
      title: "Everything to keep\na belt moving.",
      sub:
        "From emergency splices in the field to full maintenance programs in open-pit mines — we cover the full lifecycle of a rubber conveyor belt.",
      list: [
        {
          id: "hot",
          n: "01",
          t: "Hot vulcanizing",
          d: "Permanent splices using vulcanizing presses, original materials and tight temperature control. Maximum strength, long-term durability.",
          bullets: [
            "EP, NN, ST belts",
            "Widths 400–2200 mm",
            "Mobile presses on-site",
          ],
        },
        {
          id: "cold",
          n: "02",
          t: "Cold repairs",
          d: "Fast solution for unexpected stops. Industrial adhesives and rubber patches applied without heavy equipment — the belt restarts within hours.",
          bullets: [
            "24/7 emergency response",
            "High-performance adhesives",
            "Temporary or final fix",
          ],
        },
        {
          id: "splice",
          n: "03",
          t: "Belt splicing",
          d: "Mechanical and chemical splices, made at the correct angle, with alignment tools — for silent, vibration-free transfers.",
          bullets: [
            "Mechanical clip splices",
            "Vulcanized splices",
            "Alignment & calibration",
          ],
        },
        {
          id: "replace",
          n: "04",
          t: "Belt replacement",
          d: "We dismantle the old belt, supply and install the new one with our crews. New belts from partner stock or made-to-order.",
          bullets: [
            "Dismantling & recycling",
            "New belt supply",
            "Installation & tensioning",
          ],
        },
        {
          id: "maintenance",
          n: "05",
          t: "Maintenance & inspections",
          d: "Maintenance contracts with periodic inspections, wear measurements and technical reporting. Prevent failures, extend belt life.",
          bullets: [
            "Full technical audit",
            "Yearly maintenance plan",
            "Digital reporting",
          ],
        },
      ],
      extra: {
        t: "And more",
        d: "Idler repairs, belt cleaners, impact rollers, alignment and consultancy for conveyor system design.",
      },
    },
    about: {
      eyebrow: "About // Conveyor Belts S.R.L.",
      title: "Rubber, steel and\npeople who don't stop.",
      lead:
        "We are a team with roots in the heavy industry of south-eastern Romania. From Făurei, Brăila county, we travel to quarries, cement plants, ports, agricultural terminals and factories nationwide to keep conveyor belts running.",
      sections: [
        {
          t: "Our mission",
          d: "We bring downtime caused by rubber belt failures to zero. We work fast, clean and transparently — exactly the way we'd want it done for us.",
        },
        {
          t: "How we work",
          d: "Our crews show up with their own equipment — vulcanizing presses, generators, alignment tools, tensioning devices. You prepare nothing: describe the issue, we bring the solution.",
        },
        {
          t: "Standards",
          d: "We work with materials compliant with DIN 22102, EN ISO 14890 and ISO 583. Every intervention comes with a technical report and an explicit warranty.",
        },
      ],
      stats: [
        { v: "16+", l: "years of experience" },
        { v: "800+", l: "interventions completed" },
        { v: "12", l: "industries served" },
        { v: "24/7", l: "availability" },
      ],
    },
    clients: {
      eyebrow: "Clients // industries",
      title: "The people who\nset off the alarm\nat 3 in the morning.",
      lead:
        "We work with industrial operators across the country — companies for whom every minute of belt downtime means real losses.",
      industries: [
        {
          t: "Quarries & Mining",
          d: "Wide belts for aggregates, gravel, coal and ore extraction operations.",
        },
        {
          t: "Cement plants",
          d: "Transport systems for limestone, clinker and cement in high-temperature, dusty environments.",
        },
        {
          t: "Agriculture & Grain",
          d: "Port terminals and silos — transport of grain, seeds and bulk products.",
        },
        {
          t: "Construction",
          d: "Concrete batching plants, aggregate sorting and precast factories.",
        },
        {
          t: "Wood industry",
          d: "Transport of sawdust, chips and logs for sawmills and furniture factories.",
        },
        {
          t: "Recycling",
          d: "Sorting lines for solid waste, plastics and metals.",
        },
        {
          t: "Energy",
          d: "Thermal power plants and biomass plants.",
        },
        {
          t: "Ports & Terminals",
          d: "Bulk port handling — ore, grain, fertilizers.",
        },
      ],
      testimonialTitle: "What our clients say",
      logosTitle: "Companies we work with",
      logosNote: "A representative selection of industries and partners served.",
      logos: [
        "HOLCIM",
        "HEIDELBERG MATERIALS",
        "LAFARGE",
        "CARMEUSE",
        "PORT OF CONSTANȚA",
        "SOCEP",
        "TRANSPORT TRADE",
        "CEMACON",
        "AGRIROM",
        "MACON",
        "SOMACO",
        "ELPRECO",
      ],
      testimonials: [
        {
          q: "They came at night, worked 6 hours, and in the morning the belt was running. Real professionalism.",
          a: "Operations director, aggregates quarry, Buzău",
        },
        {
          q: "We've been working with them on preventive maintenance for 4 years. Zero unplanned downtime.",
          a: "Mechanical engineer, cement plant, Dobrogea",
        },
        {
          q: "Fast, fair on pricing, and the technical report actually means something.",
          a: "Port terminal manager, Constanța",
        },
      ],
    },
    contact: {
      eyebrow: "Contact // 24/7",
      title: "Tell us what\nhappened to the belt.",
      lead:
        "Send us a few details and a specialist will reach out with a preliminary estimate and an intervention timeline.",
      form: {
        name: "Full name",
        namePh: "John Doe",
        email: "Email",
        emailPh: "name@company.com",
        phone: "Phone",
        phonePh: "+40 7XX XXX XXX",
        company: "Company",
        companyPh: "Company name",
        subject: "Subject",
        subjectPh: "Urgent belt repair...",
        message: "Message",
        messagePh:
          "Describe the belt type, width, location and the nature of the problem.",
        submit: "Send message",
        sending: "Sending...",
        success: "Message sent! We'll get in touch shortly.",
        error: "Could not send the message. Please try again or call us.",
      },
      info: {
        phoneL: "Phone",
        emailL: "Email",
        addressL: "Headquarters",
        address: "Făurei, Gării st. no. 53, Brăila county, Romania",
        hoursL: "Hours",
        hours: "Interventions 24/7 · Office Mon–Fri 08:00–17:00",
      },
    },
    footer: {
      rights: "All rights reserved.",
      cui: "Conveyor Belts S.R.L. · Făurei, Brăila",
      nav: "Navigate",
      contact: "Contact",
      services: "Services",
    },
    seo: {
      home: {
        title: "Conveyor Belts S.R.L. | Rubber conveyor belts repair — Romania & Europe",
        description: "Rubber conveyor belts repair across Romania and Europe. Hot vulcanizing, cold splicing, belt joints and 24/7 maintenance. European alternative to Artego and Ikosar. Făurei, Brăila county.",
        keywords: "rubber conveyor belts repair Europe, conveyor belt splicing, hot vulcanizing Romania, cold splicing, conveyor belt maintenance, artego, ikosar, Conveyor Belts SRL Făurei",
      },
      services: {
        title: "Services — Hot vulcanizing, cold splicing & joints | Conveyor Belts",
        description: "Full-service solutions for rubber conveyor belts: hot vulcanizing, cold repairs, mechanical and chemical splices, belt replacement and preventive maintenance across Romania and Europe.",
        keywords: "hot vulcanizing conveyor belt, cold splicing rubber belt, mechanical splice, chemical splice, conveyor belt replacement, preventive maintenance Europe",
      },
      about: {
        title: "About us — Conveyor belts repair since 2008 | Conveyor Belts S.R.L.",
        description: "16+ years of experience repairing rubber conveyor belts for heavy industry across Romania and Europe. Mobile crews, own equipment, DIN 22102 and EN ISO 14890 compliant work.",
        keywords: "conveyor belts repair company Romania, Conveyor Belts SRL, Făurei Brăila, DIN 22102, EN ISO 14890, artego alternative, ikosar alternative",
      },
      clients: {
        title: "Clients & Industries served — Quarries, cement, ports | Conveyor Belts",
        description: "We serve industrial operators in quarries, cement plants, ports, agriculture, recycling, energy and construction. Real references, guaranteed response times.",
        keywords: "conveyor belt repair quarries, cement plant belts, port of Constanța belts, agriculture conveyor belts, Conveyor Belts clients",
      },
      contact: {
        title: "Contact — 24/7 intervention request | Conveyor Belts S.R.L. Făurei",
        description: "Call +40 737 906 906 or fill in the form. Conveyor belt repairs anywhere in Romania and Europe. HQ: Gării st. no. 53, Făurei, Brăila county.",
        keywords: "contact conveyor belts repair, phone Conveyor Belts, Făurei Brăila, urgent belt intervention",
      },
    },
  },
};

export const COMPANY = {
  name: "Conveyor Belts S.R.L.",
  phone: "0737.906.906",
  phoneDial: "+40737906906",
  email: "contact@conveyorbelts.ro",
  address: "Oraș Făurei, str. Gării nr. 53, jud. Brăila",
};
